'use client'
import type { FC } from 'react'
import { Badge } from '@chakra-ui/react'
import { VatToggle, type VatToggleProps } from 'ui'
import useUser from 'auth/hooks/useUser'
import { CustomerType } from 'ecosystem'
import { overrideText } from 'ui/lib/overrides'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import type { VatToggleOverrides } from 'ui/common/VatToggle'

export interface StorefrontVatToggleOverrides extends VatToggleOverrides {
  vatToggleBusinessPricingLabel?: string
}

/**
 * Storefront-aware wrapper around the dumb <VatToggle> in `ui`.
 *
 * BUSINESS customers see a non-interactive "Business pricing" badge instead of
 * the switch — their prices are always net per the BE spec and a disabled
 * toggle is more confusing than informative.
 *
 * Anonymous + CONSUMER customers get the regular toggleable switch backed by
 * localStorage.
 */
const StorefrontVatToggle: FC<VatToggleProps> = (props) => {
  const { user } = useUser()
  const overrides = useOverridesContext<keyof StorefrontVatToggleOverrides>()
  const isB2B = user?.customer?.type === CustomerType.BUSINESS

  if (isB2B) {
    return (
      <Badge
        colorScheme="purple"
        fontSize="2xs"
        px={2}
        py={1}
        textTransform="uppercase"
        whiteSpace="nowrap"
      >
        {overrideText('Företagspriser', overrides?.vatToggleBusinessPricingLabel)}
      </Badge>
    )
  }

  return <VatToggle {...props} />
}

export default StorefrontVatToggle
